import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoadingService } from "@serpro/ngx-suite-rfb";
import { appRoute } from "src/app/shared/consts/app-routes";
import { COR_SIMBOLO, COR_VIGENCIA, CorSimbolo, LEGENDAS_SIMBOLOS, LEGENDAS_VIGENCIAS, Vigencia, VisaoRelacional, VisaoRelacionalAtoCentral, VisaoRelacionalImpacto } from "src/app/shared/model/visao-relacional.model";
import { AtoService } from "src/app/shared/services/ato.service";

@Component({
    selector: 'app-visao-relacional',
    templateUrl: './visao-relacional.component.html',
    styleUrls: ['./visao-relacional.component.css']
})
export class VisaoRelacionalComponent implements OnInit {

    @Input() visaoRelacional: VisaoRelacional;
    @Input() urlFuncionalidade: string;
    // 122708
    // 121080
    // 119522

    legendasVigencias = LEGENDAS_VIGENCIAS;
    legendasSimbolos = LEGENDAS_SIMBOLOS;

    atoCentral = new VisaoRelacionalAtoCentral();
    atoCentralRetificador = false;
    exibirTela = false;

    filtrosPoloAtivo: Filtro[];
    impactosPoloAtivo: VisaoRelacionalImpacto[] = [];
    mapaPoloAtivo: Mapa[] = [];

    filtrosPoloPassivo: Filtro[];
    impactosPoloPassivo: VisaoRelacionalImpacto[] = [];
    mapaPoloPassivo: Mapa[] = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timer: any;
    preventSingleClick = false;
    delay = 300;

    constructor(
        private router: Router,
        private atoService: AtoService,
        private loadingService: LoadingService
    ) {}

    ngOnInit(): void {
        // this.idAto = this.visaoAto.idAto;
        this.filtrosPoloAtivo = [];
        this.filtrosPoloPassivo = [];
        this.mapaPoloAtivo = [];
        this.mapaPoloPassivo = [];

        this.atoCentral = this.visaoRelacional.atoCentral;
        this.atoCentralRetificador = this.atoCentral.vigencia == 5;
        this.gerarMapa(this.visaoRelacional.impactosPoloAtivo, false);
        this.gerarMapa(this.visaoRelacional.impactosPoloPassivo, true);
        this.gerarFiltros(false);
        this.gerarFiltros(true);
        this.exibirTela = true;



        // this.buscarVisaoRelacionalDoAto();
    }

    // buscarVisaoRelacionalDoAto() {
    //     this.loadingService.show();
    //     this.atoService.buscarVisaoRelacionalDoAto(this.idAto).subscribe({
    //         next: visaoRelacional => {
    //             this.atoCentral = this.visaoRelacional.atoCentral;
    //             this.atoCentralRetificador = this.atoCentral.vigencia == 5;
    //             this.gerarMapa(this.visaoRelacional.impactosPoloAtivo, false);
    //             this.gerarMapa(this.visaoRelacional.impactosPoloPassivo, true);
    //             this.gerarFiltros(false);
    //             this.gerarFiltros(true);
    //             this.exibirTela = true;
    //             this.loadingService.hide();
    //         },
    //         error: () => this.loadingService.hide()
    //     })
    // }

    gerarMapa(impactos: VisaoRelacionalImpacto[], isPoloPassivo: boolean) {
        const anos = impactos.map(i => this.obterDataDeAgrupamentoAtos(i, isPoloPassivo).substring(6));
        const unique = [...new Set(anos)].sort();
        for (const ano of unique) {
            const mapa = new Mapa();
            mapa.ano = ano;
            mapa.impactos = impactos.filter(i => this.obterDataDeAgrupamentoAtos(i, isPoloPassivo).substring(6) == ano);
            if (isPoloPassivo) {
                this.mapaPoloPassivo.push(mapa);
            } else {
                this.mapaPoloAtivo.push(mapa);
            }
        }
    }

    private obterDataDeAgrupamentoAtos(impacto: VisaoRelacionalImpacto, isPoloPassivo: boolean) {
        if (isPoloPassivo && this.visaoRelacional.anotacoesAtivasTemDataVigencia ||
            !isPoloPassivo && this.visaoRelacional.anotacoesPassivasTemDataVigencia) {
                return impacto.dataVigenciaPrimeiraAnotacao;
        } else {
            return impacto.dataAtoDMY;
        }
    }

    gerarFiltros(isPoloPassivo: boolean) {
        const mapa = isPoloPassivo ? this.mapaPoloPassivo : this.mapaPoloAtivo;
        const filtro = isPoloPassivo ? this.filtrosPoloPassivo : this.filtrosPoloAtivo;
        filtro.splice(0, filtro.length);
        for (const ano of mapa) {
            for (const impacto of ano.impactos) {
                const sigla = impacto.sigla;
                const encontrado = filtro.find(f => f.sigla == sigla);
                if (encontrado) {
                    encontrado.quantidade++;
                } else {
                    filtro.push(new Filtro(sigla, impacto.corSimbolo, impacto.hint, 1, isPoloPassivo));
                }
            }
        }
    }

    getEstiloSeta(isPoloPassivo: boolean) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const style: any = {};
        
        const height = document.getElementById('ato-central')?.clientHeight;
        if (height) {
            style['height'] = height + 'px';
        }

        const setaAtiva = 'url(assets/imagens/arvore/setaBoxAtiva.png';
        const setaInativa = 'url(assets/imagens/arvore/setaBoxInativa.png';
        if (isPoloPassivo) {
            style['background-image'] =  this.mapaPoloPassivo.length > 0 ? setaAtiva : setaInativa;
        } else {
            style['background-image'] =  this.mapaPoloAtivo.length > 0 ? setaAtiva : setaInativa;
        }
        return style;
    }

    getStyleCorSimbolo(corSimbolo: CorSimbolo): object {
        let cor = COR_SIMBOLO[0];
        if (corSimbolo >= 1 && corSimbolo <= 6) {
            cor = COR_SIMBOLO[corSimbolo - 1];
        }
        return {'color': this.getCssColor(cor)}
    }

    getStyleCorVigencia(vigencia: Vigencia): object {
        if (vigencia) {
            const i = vigencia - 1;
            const cor = COR_VIGENCIA[i];
            return {'background-color': this.getCssColor(cor)}
        }
        return {};
    }

    getStyleFiltro(filtro: Filtro): object {
        if (filtro.ativo) {
            return this.getStyleCorSimbolo(filtro.corSimbolo)
        }
        return {'color': this.getCssColor([208,208,208])}
    }

    getCssColor(rgb: number[]): string {
        return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2]+')';
    }

    clickFiltro(filtro: Filtro) {
        const lista = filtro.poloPassivo ? this.filtrosPoloPassivo : this.filtrosPoloAtivo;
        if (filtro.selecionado) {
            filtro.selecionado = false;
            lista.forEach(f => f.ativo = true);
        } else {
            lista.forEach(f => f.ativo = false);
            lista.forEach(f => f.selecionado = false);
            filtro.selecionado = true;
            filtro.ativo = true;
        }
    }

    buscarAtosFiltrados(ano: string, isPoloPassivo: boolean) {
        const lista = isPoloPassivo ? this.mapaPoloPassivo : this.mapaPoloAtivo;
        const filtro = isPoloPassivo ? this.filtrosPoloPassivo : this.filtrosPoloAtivo;
        const mapa = lista.find(m => m.ano === ano);
        return mapa?.impactos.filter(a => {
            const sigla = a.sigla;
            return filtro.find(f => f.sigla == sigla && f.ativo == true) ? true : false;
        })
    }

    singleClick(impacto: VisaoRelacionalImpacto) {
        this.preventSingleClick = false;
        this.timer = setTimeout(() => {
            if (!this.preventSingleClick) {
                if (this.urlFuncionalidade) {
                    this.router.navigate([`${this.urlFuncionalidade}/${impacto.idAto}/visao/relacional`]);
                } else {
                    this.router.navigate([`${appRoute.ato.visualizarAto}/${impacto.idAto}/visao/relacional`]);
                }
            }
        }, this.delay);
    }

    doubleClick(impacto: VisaoRelacionalImpacto) {
        this.preventSingleClick = true;
        clearTimeout(this.timer);
        if (this.urlFuncionalidade) {
            this.router.navigate([`${this.urlFuncionalidade}/${impacto.idAto}/visao/multivigente`]);
        } else {
            this.router.navigate([`${appRoute.ato.visualizarAto}/${impacto.idAto}/visao/multivigente`]);
        }
    }
}

class Filtro {
    sigla: string;
    corSimbolo: CorSimbolo;
    hint: string;
    quantidade: number;
    ativo = true;
    selecionado = false;
    poloPassivo: boolean;
    constructor (s: string, c: CorSimbolo, h: string, q: number, isPoloPassivo: boolean) {
        this.sigla = s;
        this.corSimbolo = c;
        this.hint = h;
        this.quantidade = q;
        this.poloPassivo = isPoloPassivo;
    }
}

class Mapa {
    ano: string;
    expandir = true;
    impactos: VisaoRelacionalImpacto[];
}
